import { ApiResponseModel } from '../types/ApiResponseModel';
import { CourseCodeFormViewModel } from '../types/CourseCodeFormViewModel';
import { DataRequestConfig } from '../types/DataRequestConfig';
import { getApiBaseUrl } from './app.service';
import { executeApiRequest, getAuthToken } from './base.service';
import { getHttpClient, HttpClient } from './httpClient';

export const commonApiPaths = {
  getForm: 'common/courseCodeData',
  getFormFullGradeDescriptions: 'common/courseCodeDataFullGradeDescriptions',
};

export const CommonServiceClient = (
  config?: DataRequestConfig
): HttpClient =>
  getHttpClient(getApiBaseUrl(), getAuthToken() || '', config?.signal);

export const getCourseCodeFormViewModel = async (
  config?: DataRequestConfig
): Promise<ApiResponseModel<CourseCodeFormViewModel>> => {
  return executeApiRequest<CourseCodeFormViewModel>(async () => {
    return await CommonServiceClient(config).get(
      commonApiPaths.getForm
    );
  });
};

export const getCourseCodeFormViewModelFullGradeDescriptions = async (
  config?: DataRequestConfig
): Promise<ApiResponseModel<CourseCodeFormViewModel>> => {
  return executeApiRequest<CourseCodeFormViewModel>(async () => {
    return await CommonServiceClient(config).get(
      commonApiPaths.getFormFullGradeDescriptions
    );
  });
};